<template>
  <div>
    <a-drawer :title="`创建Android应用事件资产`" :width="700" :visible="showAndroidEventAssetForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">

        <a-spin :spinning="loading" tip="Loading..." size="large">

          <a-divider orientation="left">应用信息</a-divider>

          <a-form-model-item label="应用名称">
            <a-input v-model="model.app_name" disabled />
          </a-form-model-item>

          <a-form-model-item label="应用包名">
            <a-input v-model="model.package_name" disabled />
          </a-form-model-item>

          <a-form-model-item label="App ID">
            <a-input v-model="model.app_id" disabled />
          </a-form-model-item>

          <a-form-model-item label="下载链接">
            <a-input v-model="model.download_url" disabled />
          </a-form-model-item>

          <a-divider orientation="left">事件配置</a-divider>

          <a-form-model-item label="事件列表">
            <a-checkbox-group v-model="model.event_ids" :options="eventOptions" />
          </a-form-model-item>

          <a-form-model-item label="回传方式">
            <a-tag color="blue">应用API回传</a-tag>
          </a-form-model-item>

          <a-divider orientation="left">监测链接配置</a-divider>

          <a-form-model-item label="监测链接组名称" prop="track_url_group_name">
            <a-input v-model="model.track_url_group_name" placeholder="请输入监测链接组名称" />
          </a-form-model-item>

          <a-form-model-item label="有效触点/点击" prop="action_track_url">
            <a-input v-model="model.action_track_url" placeholder="请输入有效触点监测链接，需要以https://开头" />
          </a-form-model-item>

          <a-form-model-item label="展示监测">
            <a-input v-model="model.track_url" placeholder="请输入展示监测链接，需要以https://开头" />
          </a-form-model-item>

          <a-form-model-item label="视频播放">
            <a-input v-model="model.video_play_track_url" placeholder="请输入视频播放监测链接，需要以https://开头" />
          </a-form-model-item>

          <a-form-model-item label="视频播完">
            <a-input v-model="model.video_play_done_track_url" placeholder="请输入视频播完监测链接，需要以https://开头" />
          </a-form-model-item>

          <a-form-model-item label="视频有效播放">
            <a-input v-model="model.video_play_effective_track_url" placeholder="请输入视频有效播放监测链接，需要以https://开头" />
          </a-form-model-item>

          <a-form-model-item label="激活监测">
            <a-input v-model="model.active_track_url" placeholder="请输入激活监测链接，需要以https://开头" />
          </a-form-model-item>

          <div class="result" v-if="result.task_ids && result.task_ids.length > 0">
            <a-divider orientation="left">任务提交结果</a-divider>
            <a-alert
              type="success"
              show-icon
              :message="`已提交 ${result.total} 条Android应用事件资产任务`"
              description="任务将由后台脚本执行，失败后可在应用事件任务列表按单条广告主重试。"
            />
            <div class="task-ids">
              任务ID：{{ result.task_ids.join('、') }}
            </div>
          </div>

        </a-spin>
      </a-form-model>

      <div v-if="showSubmit" :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>

    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'CreateAndroidEventAsset';
</style>

<script>
import CreateAndroidEventAsset from './CreateAndroidEventAsset'

export default CreateAndroidEventAsset
</script>
